<template>
  <div>
    <div class="daily-cargo-flight-administration">
      <div>
        <!-- <form-button
          @onClick="saveFlights">
          Save Flights
        </form-button> -->
        <form-button
          @onClick="saveDefaultFlights">
          Update Default
        </form-button>
      </div>
      <table>
        <thead>
          <tr class="daily-cargo-flight-administration__head">
            <th>Flying</th>
            <th
              v-for="(header, index) in tableFields"
              :key="'dashboardPrecariageHeader' + index">
              <span />
              {{ header.label }}
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(dailyCargo, dailyCargoIndex) in sortedDailyCargoFlights"
            :key="'dailyCargoTable' + dailyCargoIndex">
            <td>
              <form-toggle-switch
                v-model="dailyCargo.Is_Flying"
                text-unchecked="No"
                text-checked="Yes"
                @input="saveIndividualFlight(dailyCargo)" />
            </td>
            <td
              v-for="(field, fieldIndex) in tableFields"
              :key="'dashboardPrecariageField' + dailyCargoIndex + '.' + fieldIndex"
              class="daily-cargo-flight-administration__field">
              <span>
                {{ formatField(dailyCargo[field.name], field.type) }}
              </span>
            </td>
            <td>
              <form-button
                class="spl-daily-cargo-table__edit"
                @onClick="editData(dailyCargo)">
                <img src="../../../assets/icon-edit.svg">
              </form-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        Note: Changes are automatically saved when toggling the "Flying" switch.
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Helpers from '@/helpers.vue'
import constants from '@/constants'

export default {
  mixins: [Helpers],
  data () {
    return {
      tableFields: [
        // { name: 'Daily_Cargo_Flight_ID', label: 'Saved', type: 'Saved' },
        { name: 'Flight_Name', label: 'Flight Name', type: 'String' },
        { name: 'Daily_Cargo_Flight_Aircraft', label: 'Flight Aircraft', type: 'String' },
        { name: 'Daily_Cargo_Flight_Registration', label: 'Flight Registration', type: 'String' },
        { name: 'Daily_Cargo_Flight_Number', label: 'Flight Number', type: 'String' },
        { name: 'Daily_Cargo_Flight_Operator', label: 'Flight Operator', type: 'String' },
        { name: 'Estimated_Time_Of_Departure', label: 'Est. Time of Departure', type: 'String' },
        { name: 'Estimated_Time_Of_Arrival', label: 'Est. Time of Arrival', type: 'String' },
        { name: 'Daily_Cargo_Flight_Timestamp', label: 'Flight Timestamp', type: 'Date' }
      ],
      constants
    }
  },
  computed: {
    ...mapGetters('dailyCargo', ['dailyCargoFlights']),
    sortedDailyCargoFlights: function () {
      function compareFlightNumber (a, b) {
        if (a.Daily_Cargo_Flight_Number < b.Daily_Cargo_Flight_Number) {
          return -1
        }
        if (a.Daily_Cargo_Flight_Number > b.Daily_Cargo_Flight_Number) {
          return 1
        }
        return 0
      }

      return this.dailyCargoFlights.filter(d => d.Flight_Name !== '').sort(compareFlightNumber)
    }
  },
  created () {
    this.loadDailyCargoFlights()
  },
  methods: {
    ...mapActions('dailyCargo', ['loadDailyCargoFlights', 'saveDailyCargoFlight', 'saveDailyCargoDefaultFlight']),
    editData (dailyCargo) {
      this.$router.push({ name: 'daily-cargo-edit-flight-administration', params: dailyCargo })
    },
    formatField (field, type) {
      if (type === 'Date') {
        return this.formatDate(field, false, 'YYYY-MM-DD')
      } else if (type === 'Time') {
        return this.formatDate(field, true, 'YYYY-MM-DD HH:mm')
      } else if (type === 'Number.2') {
        return this.numberFormat(field, 2, false)
      } else if (type === 'Saved') {
        if (field === -1) {
          return 'NOT SAVED'
        } else {
          return 'OK'
        }
      }
      // empty fields will be removed
      if (field == null || field === 0) {
        return ''
      }
      return field
    },
    saveIndividualFlight (dailyCargo) {
      var array = [dailyCargo]

      this.saveDailyCargoFlight(array).then(() => {
        this.loadDailyCargoFlights()
        this.$forceUpdate()
      })
    },
    saveFlights (dailyCargo) {
      this.saveDailyCargoFlight(this.dailyCargoFlights).then(() => {
        this.loadDailyCargoFlights()
        this.$forceUpdate()
      })
    },
    saveDefaultFlights () {
      this.saveDailyCargoDefaultFlight(this.dailyCargoFlights)
    }
  }
}
</script>
<style lang="scss">
  @import '../../../variables.scss';
  .daily-cargo-flight-administration {
    width: 100%;
    height: calc(100vh - 205px);
    padding-bottom: 20px;
    overflow: auto;

    &__fields {
      display: grid;
      grid-template-columns: 19% 19% 19% 19% 19%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 1%;
    }

    table {
      border-spacing: 0;
      table-layout: fixed;
    }
    &__head {
      th {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.1);
      }
      &--sticky {
        position: sticky;
        left: 41px;
        z-index: 3 !important;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 10px 2px 0 6px;
        }
        position: sticky;
        left: 0px;
        z-index: 3 !important;
      }
    }
    &__row {
      &--selected {
        background-color: $tableRowBackgroundColorSelected !important;
      }
      &--deleted {
        opacity: 0.3;
        background-color: lightgrey !important;
      }
    }
    &__field {
      &--number {
        text-align: right;
        width: 70px;
      }
      &--sticky {
        position: sticky;
        left: 41px;
        box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.2);
        background-color: $tableHeaderBackgroundColor;
      }
      &--long {
        max-width: 400px !important;
        white-space: nowrap;
      }
      &--success {
        border-bottom: 2px solid $green !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $green;
      }
      &--warning {
        border-bottom: 2px solid $darkYellow !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $darkYellow;
      }
      &--error {
        border-bottom: 2px solid $red !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $red;
      }
      &--bold {
        font-weight: 600;
      }
      &--empty:hover {
        background-color: $tableRowBackgroundColorHover !important;
      }
    }
    thead {
      th {
        position: sticky;
        top: 0;
        text-align: left;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 12px;
        background-color: $tableHeaderBackgroundColor;
        padding: 0px 5px  0px 5px;
        height: 40px;
        border-bottom: 1px solid $tableHeaderBorderColor;
      }

      th:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }
    }
    tbody {
      tr {
        background-color: $tableRowBackgroundColor;
        &:nth-child(even) {
          background: $tableHeaderBackgroundColor;
        }
      }
      tr:hover {
        background-color: $tableRowBackgroundColorHover;
      }
      td {
        border-style: solid;
        border-width: 0 1px 1px 0;
        border-color: $tableRowBorderLowColor;
        border-bottom-color: $tableRowBorderColor;
        font-size: 12px;
        padding: 5px;
        padding-top: 8px;
        white-space: nowrap;
      }
      td:hover {
        background-color: $tableColumnBackgroundColorHover;
      }
      td:first-child {
        border-left-width: 1px;
      }
    }
  }
</style>
